import { Directive, OnInit, Output, EventEmitter, Input, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[appBaseListHeader]',
})
export class BaseListHeaderDirective implements OnInit {

  @Input() sortField: string;
  @Output() sort = new EventEmitter();
  private _direction;
  private iconDESC = 'fa-sort-down';
  private iconASC = 'fa-sort-up';
  private iconSort = 'fa-sort';

  @Input('direction')
  set direction(value) {
    if (this.arrowEl) {
      this.setDirectionIcon(value);
    }
    this._direction = value;
  }
  get direction() {
    return this._direction;
  }

  private arrowEl: any;

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.arrowEl = this.renderer.createElement('span');
    this.renderer.addClass(this.elRef.nativeElement, 'pointer');
    this.renderer.appendChild(this.elRef.nativeElement, this.arrowEl);

    this.setDirectionIcon(this.direction);
  }

  @HostListener('click')
  onChangeDirection() {
    switch (this.direction) {
      case undefined: {
        this.direction = 'ASC';
      } break;
      case 'ASC': {
        this.direction = 'DESC';
      } break;
      case 'DESC': {
        this.direction = undefined;
      } break;
    }

    this.sort.next({ field: this.sortField, direction: this.direction });
  }

  setDirectionIcon(value) {
    this.renderer.removeClass(this.arrowEl, this.iconASC);
    this.renderer.removeClass(this.arrowEl, this.iconDESC);
    this.renderer.removeClass(this.arrowEl, this.iconSort);
    this.renderer.removeClass(this.arrowEl, 'fal');
    this.renderer.removeClass(this.arrowEl, 'fas');

    if (value === 'ASC') {
      this.renderer.addClass(this.arrowEl, this.iconASC);
      this.renderer.addClass(this.arrowEl, 'fas');
    } else if (value === 'DESC') {
      this.renderer.addClass(this.arrowEl, this.iconDESC);
      this.renderer.addClass(this.arrowEl, 'fas');
    } else {
      this.renderer.addClass(this.arrowEl, this.iconSort);
      this.renderer.addClass(this.arrowEl, 'fal');
    }
  }

}
